import type { Theme } from '@mui/material';

export const styles = {
  headline: (theme: Theme) => ({
    color: theme.colors.primary[500],
    mb: 2,
  }),

  listWrapper: (theme: Theme) => ({
    color: theme.colors.neutral[700],
    height: '100%',
    overflow: 'auto',

    '.MuiLink-root': {
      color: theme.colors.neutral[700],
      textDecorationColor: theme.colors.neutral[700],
    },
  }),
};
